import gql from 'graphql-tag';

const GET_CAMPAIGNSLIST = gql`
  query campaigns($limit: Int, $skip: Int, $ignoreStatus: Boolean) {
    campaigns(limit: $limit, skip: $skip, ignoreStatus: $ignoreStatus) {
      data {
        name
        status
      }
      limit
      skip
    }
  }
`;

export default GET_CAMPAIGNSLIST;
